import { ListResult } from '@angular/fire/storage';

export class ListAllSuccessEffect {
  public static readonly type = '[Project/Storage/List] ListAllSuccessEffect';
  constructor(public readonly result: ListResult) {}
}
